import { useEffect, useRef } from 'react';

export interface StakePresetsOptions {
  // The preferences response. Undefined until it lands.
  preferences?: { stakes?: number[] };
  presetCount: number;
  minBet: number;
  setBetValues: (values: number[]) => void;
  setCurrentBetAmount: (amount: number) => void;
}

// Loads saved chips once, then starts at the currency minimum.
export function useStakePresets({
  preferences,
  presetCount,
  minBet,
  setBetValues,
  setCurrentBetAmount,
}: StakePresetsOptions): void {
  const loaded = useRef(false);
  const previousMin = useRef<number | null>(null);

  useEffect(() => {
    if (preferences && !loaded.current) {
      const presets = preferences.stakes?.slice(0, presetCount);
      if (presets?.length) setBetValues(presets);
      loaded.current = true;
    }
    // The minimum arrives with the game config, so take it then.
    if (loaded.current && previousMin.current !== minBet) {
      setCurrentBetAmount(minBet);
      previousMin.current = minBet;
    }
  }, [preferences, presetCount, minBet, setBetValues, setCurrentBetAmount]);
}
